import { render, staticRenderFns } from "./SeniorMembersDisplay.vue?vue&type=template&id=20f0c05a"
import script from "./SeniorMembersDisplay.vue?vue&type=script&lang=js"
export * from "./SeniorMembersDisplay.vue?vue&type=script&lang=js"
import style0 from "./SeniorMembersDisplay.vue?vue&type=style&index=0&id=20f0c05a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports